export default __webpack_public_path__ + "static/media/logo4.3855e61d.png";